import React, { useEffect } from 'react';
import { FormattedMessage, MessageDescriptor, useIntl } from 'react-intl';

import { ButtonModel, PictogramSolidError } from '@notino/react-styleguide-v20';

import { IErrorMessages } from '@model';
import { EcommerceSectionNamespace, trackCheckoutWtPayFail } from '@services/ecommerceService';
import { ReactFCV } from '@types';
import { noop } from '@utils/general';

import { ErrorWrapper, StyledButtons, StyledErrorMessage } from './styled';

export interface IPaymentErrorProps {
  onRepeatPayment: () => void;
  onReturnToPreviousStep?: () => void;
  messages: IErrorMessages;
  amount: number;
  provider: EcommerceSectionNamespace.EEcommercePaymentProvider;
  providerType: string;
  titleMessage: MessageDescriptor;
  showButtons?: boolean;
}

export const PaymentError: ReactFCV<IPaymentErrorProps> = ({
  messages,
  onRepeatPayment,
  onReturnToPreviousStep,
  provider,
  providerType,
  amount,
  titleMessage,
  showButtons = true,
}) => {
  const { formatMessage } = useIntl();
  useEffect(() => {
    trackCheckoutWtPayFail(provider, providerType, amount, formatMessage(titleMessage));
  }, [amount, providerType, formatMessage, messages, provider, titleMessage]);
  return (
    <ErrorWrapper>
      <PictogramSolidError height={'60px'} width={'60px'} />
      <StyledErrorMessage>
        <FormattedMessage {...titleMessage} />
      </StyledErrorMessage>
      {showButtons && (
        <StyledButtons
          firstButtonProps={{
            text: formatMessage(messages.returnToPreviousStep),
            isVisible: Boolean(onReturnToPreviousStep),
            onClickAction: onReturnToPreviousStep ?? noop,
          }}
          secondButtonProps={{
            text: formatMessage(messages.repeatPayment),
            isVisible: true,
            onClickAction: onRepeatPayment,
          }}
          buttonsSize={ButtonModel.Sizes.default}
          mobileButtonOrder={false}
        />
      )}
    </ErrorWrapper>
  );
};
